export function addClassName(element: Element | null, className: string): void {
    if (element && !element.classList.contains(className)) {
        element.classList.add(className);
    }
}

export function removeClassName(element: Element | null, className: string): boolean {
    if (element && element.classList.contains(className)) {
        element.classList.remove(className);
        return true;
    }
    return false;
}

export function replaceClassName(
    element: Element | null,
    existingClassName: string,
    newClassName: string
): boolean {
    const hasRemoved = removeClassName(element, existingClassName);
    if (hasRemoved) {
        addClassName(element, newClassName);
    }
    return hasRemoved;
}

export function getClassNamesStartingWith(prefix: string, root: ParentNode = document): string[] {
    const matches = new Set<string>();

    const elements = root.querySelectorAll<HTMLElement>("[class]");
    elements.forEach(el => {
        el.classList.forEach(cls => {
            if (cls.startsWith(prefix)) {
                matches.add(cls);
            }
        });
    });

    return Array.from(matches);
}

export function findDescendentById(
    el: HTMLElement | null,
    id: string
): HTMLElement | null {
    let descendent: HTMLElement | null = null;

    if (el !== null) {
        if (el.id === id) {
            return el;
        }

        const children = Array.from(el.children) as HTMLElement[];

        for (const child of children) {
            descendent = findDescendentById(child, id);
            if (descendent !== null) {
                return descendent;
            }
        }
    }

    return null;
}

